export enum TrainingObjective {
  Health = "salud",
  Hypertrophy = "hipertrofia",
  Definition = "definicion",
}
